import React from 'react';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import CapacidadFuncionalTable from '../components/CapacidadFuncionalTable';

export default function CapacidadFuncionalListPage() {
  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <CapacidadFuncionalTable />
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}
